import script from "./SkillAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillAccordion.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__